import { UserRole } from '../types';
import apiClient from './apiClient';

const ROLES_KEY = 'roles';

const getRoles = async () => {
	const response = await apiClient.get<UserRole[]>('/auth/roles');
	return response.data;
};

const RolesApi = {
	getRoles,
	ROLES_KEY,
};

export default RolesApi;
